<div class="col">
  <div class="row">
    <div class="col-md-5 pr-0">
      <p class="f-12 mb-1"> Filter </p>
      <div class="mb-1 d-flex justify-content-between">
        <select data-testid="auto-app-person-search-activity-select-1" class="nobg wc-form-control-activity pipeline-text-border"
          (change)="filterByActivityType($event.target.value)">
          <option value="all">All Activity type</option>
          <option value="{{type}}" *ngFor="let type of activityType"> {{type}} </option>
        </select>
        <div class="selectdrop-down position-relative tr-n f-12 mt-3 mr-2" style="
        top: -8px;
        right: 20px;"><i class="fas fa-chevron-down"></i></div>
      </div>
    </div>
    <div class="col-md-5 pl-0">
      <p class="f-12 mb-1"> Sort </p>
      <span class="mb-1 d-flex justify-content-between">
        <select data-testid="auto-app-person-search-activity-select-2" class="nobg wc-form-control-activity pipeline-text-border" (change)="sortActivity($event.target.value)">
          <option value="recent" selected>Most Recent</option>
          <option value="oldest">Oldest</option>
        </select>
        <span class="selectdrop-down position-relative tr-n f-12 mt-3 mr-2" style="
        top: -8px;
        right: 20px;"><i class="fas fa-chevron-down"></i></span>
      </span>
    </div>
  </div>
</div>


<!-- <div *ngIf="candidateActivity">
  <div *ngFor="let activity of candidateActivity">
    {{activity.activitytype}} 


    <i class="fas fa-circle mr-2" style="font-size: 5px;"></i>
    <span class="mr-2">{{activity?.createdon | date: 'MMM dd, yyyy'}}</span>
    <i class="fas fa-circle mr-2" style="font-size: 5px;"></i>
    <span>{{activity?.createdon | date: 'h:mm a'}}</span>
  </div>
</div> -->




<div class="col">


  <div class="activities-list mt-4" *ngIf="candidateActivity">
    <div class="candidate-activities" *ngFor="let activity of candidateActivity; let i = index">
      <div class="note">
        <div class="row mb-1">
          <div class="col d-flex">
            <div class="">
              <i class="fas fa-circle f-12 webtree-btn-1"></i>
            </div>
            <div class="col gray-text f-12 line-height-1 pl-2">
              <p class="mb-0" class="activity">
                <span [innerHTML]="getActivityText(activity)"></span>
              </p>
            </div>
            <!-- <div class="col d-flex justify-content-between">
          <span class="f-14 font-weight-500"
            *ngIf="activity.action == 'note' || activity.action == 'create' ">
            Note Added
          </span>
          <span class="f-14 font-weight-500" *ngIf="activity.action == 'update'">
            Note Updated
          </span>
          <div>
            <span class="gray-text f-12 mr-1">
              {{ activity.createdon | date: 'MMM d, y h:mm a'}}
            </span>
            <span class="font-weight-bold f-14 pointer">
              <i class="fas fa-edit f-12 webtree-btn" (click)="editNote(activity);"></i>
            </span>
          </div>
        </div> -->
          </div>
        </div>

        <div class="row mb-1">
          <div class="col d-flex">
            <div class="pr-2 d-flex align-items-stretch">
              <div class=" spacer2 pr-2 spacer-border"></div>
            </div>
            <div class="col gray-text f-12 line-height-1">
              <p class="mb-4 f-12">
                <span class="mr-3 f-12">{{activity?.username }}</span>
                <span style="position: relative;">
                  <i class="fas fa-circle mr-3" style="font-size: 5px; position: absolute; top: 7px; right: -9px;"></i>
                </span>
                <span class="mr-3">{{activity?.createdon | date: 'MMM dd, yyyy'}}</span>
                <span style="background-color: red; position: relative;" >
                  <i class="fas fa-circle mr-2" style="font-size: 5px; position: absolute; top: 7px; right: -6px;"></i>
                </span>
                <span>{{activity?.createdon | date: 'h:mm a'}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>